import { render, staticRenderFns } from "./ChatFansComp.vue?vue&type=template&id=a37e4ff4&"
import script from "./ChatFansComp.vue?vue&type=script&lang=js&"
export * from "./ChatFansComp.vue?vue&type=script&lang=js&"
import style0 from "./ChatFansComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports